// ModalContext.ts
import { createContext } from 'react';

export type ModalVariant = 'neutral' | 'warning' | 'dark';

export const ModalVariantContext = createContext<ModalVariant>('neutral');